module.exports = __webpack_public_path__ + "media/images/clippy-89bd48cb.svg";